import { generateTheme } from "./generateTheme";

const lightTheme = generateTheme("light");
const darkTheme = generateTheme("dark");

export { lightTheme, darkTheme };